
























import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';

import { MediaQueryService, WB_RESIZE_EVENT_NAME, mobileBreakpoints } from '@owc-utils/MediaQueryService';
// Importing MediaQueryChangeEvent type declaration
import { MediaQueryChangeEvent } from '@owc-utils/MediaQueryService/MediaQueryChangeEvent';
import { ButtonType } from '@owc-types/Button.enum';
import { BaseCtaLink } from '@owc-types/BaseCtaLink';

/**
 * A CTA button mainly used in the stage component.
 * Provides the user with the possibility to do somethig based on a given context.
 */
export default ComponentInitializeDispatcher.extend({
  name: 'owc-stage-cta-buttons',
  props: {
    buttons: {
      type: Array as () => Array<BaseCtaLink>,
      required: true,
    },
    isDarkMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ctas(): BaseCtaLink[] {
      const primaryButton = this.buttons.find(({ type }) => type === ButtonType.Primary);
      const secondaryButton = this.buttons.find(({ type }) => type === ButtonType.Secondary);
      // Due to workbench a primary button must to be on the right
      return [secondaryButton, primaryButton].filter(cta => cta) as BaseCtaLink[];
    },
  },
  data() {
    return {
      wbMediaQueryService: new MediaQueryService(window),
      isMobile: true,
    };
  },
  mounted(): void {
    // Used to change image ratio given a MediaQuery Event
    window.addEventListener(
      WB_RESIZE_EVENT_NAME,
      this.resizeEventHandler as EventListenerOrEventListenerObject,
    );
    this.wbMediaQueryService.observe(true);
  },
  beforeDestroy(): void {
    window.removeEventListener(
      WB_RESIZE_EVENT_NAME,
      this.resizeEventHandler as EventListenerOrEventListenerObject,
    );
  },
  methods: {
    resizeEventHandler(resizeEvent: CustomEvent<MediaQueryChangeEvent>) {
      this.isMobile = mobileBreakpoints.includes(resizeEvent.detail.current);
    },
    getCtaButtonClasses(cta: BaseCtaLink): string {
      if (cta.type === ButtonType.Primary) {
        return 'wb-button--primary owc-stage-cta-buttons__button--primary';
      }
      return 'wb-button--secondary owc-stage-cta-buttons__button--secondary';
    },
  },
});
